module.exports = __webpack_public_path__ + "static/media/Pattern2.4fb47c7d.jpg";